import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image = 'https://customer-assets.emergentagent.com/job_nordic-order/artifacts/90mcbk8m_IMG20251031144115.jpg',
  url = 'https://ravintolasunsari.fi',
  type = 'website'
}) => {
  const defaultTitle = 'Sunsari Restaurant Vaasa | Authentic Nepalese & Indian Cuisine | Ravintola Vaasa';
  const defaultDescription = 'Best Nepalese & Indian restaurant in Vaasa, Finland. Authentic flavors, weekly lunch specials, catering services. Paras nepalilais-intialainen ravintola Vaasassa. Äkta nepalesisk och indisk restaurang i Vasa.';
  const defaultKeywords = 'Sunsari, restaurant Vaasa, ravintola Vaasa, restaurang Vasa, Nepalese restaurant, Indian restaurant, intialainen ravintola, nepalilainen ravintola, indisk restaurang, nepalesisk restaurang, lunch Vaasa, lounas Vaasa, lunch Vasa, butter chicken Vaasa, catering Vaasa, pitopalvelu Vaasa, table booking Vaasa, pöytävaraus Vaasa, bordbokning Vasa, best restaurant Vaasa, paras ravintola Vaasa, bästa restaurangen Vasa';

  const siteTitle = title ? `${title} | Sunsari Restaurant Vaasa` : defaultTitle;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Language Tags */}
      <html lang="fi" />
      <meta httpEquiv="content-language" content="fi, sv, en" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fi_FI" />
      <meta property="og:locale:alternate" content="sv_SE" />
      <meta property="og:locale:alternate" content="en_US" />
      <meta property="og:site_name" content="Sunsari Restaurant Vaasa" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image} />
      
      {/* Restaurant Schema.org Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Restaurant",
          "name": "Sunsari Restaurant",
          "image": image,
          "description": description || defaultDescription,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Vaasa",
            "addressLocality": "Vaasa",
            "addressRegion": "Ostrobothnia",
            "postalCode": "65100",
            "addressCountry": "FI"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "63.0951",
            "longitude": "21.6156"
          },
          "telephone": "+358403779200",
          "email": "ravintolasunsari@gmail.com",
          "servesCuisine": ["Nepalese", "Indian", "Asian"],
          "priceRange": "€€",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Monday",
              "opens": "11:00",
              "closes": "15:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Tuesday", "Wednesday", "Thursday"],
              "opens": "11:00",
              "closes": "21:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Friday",
              "opens": "11:00",
              "closes": "22:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "12:00",
              "closes": "22:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Sunday",
              "opens": "12:00",
              "closes": "20:00"
            }
          ],
          "acceptsReservations": "True",
          "hasMenu": url + "/menu",
          "url": url,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.5",
            "reviewCount": "150"
          }
        })}
      </script>
      
      {/* Local Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Sunsari Restaurant",
          "alternateName": ["Ravintola Sunsari", "Restaurang Sunsari"],
          "description": "Authentic Nepalese and Indian cuisine in Vaasa, Finland",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Vaasa",
            "addressRegion": "Ostrobothnia",
            "addressCountry": "Finland"
          },
          "telephone": "+358403779200",
          "email": "ravintolasunsari@gmail.com",
          "url": url
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
